/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { useTranslation } from 'react-i18next';
import { BodyText, Heading, Size } from '@vaisala-rockhopper/components';
import { ModalInstance, ModalProps } from './Modals';
import './Modals.scss';

const DwellModal = (props: ModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalInstance modalId="modal.dwell" {...props} title={t('card.dwell')} size={Size.L}>
      <Heading level={4}>{t('card.dwell')}</Heading>

      <BodyText>{t('modalText.dwell')}</BodyText>
      <BodyText>{t('modalText.dwell2')}</BodyText>
    </ModalInstance>
  );
};

export default DwellModal;
